module.exports = __webpack_public_path__ + "static/automated-account-provisioning-0f67506de2ecfef6d914d2131a5eae0a.png";